import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';
import '!style-loader!css-loader!../../css/colors.css';
import '!style-loader!css-loader!../../css/froala.css';
import '!style-loader!css-loader!../../css/banners.css';
import '!style-loader!css-loader!../../css/post-card-statistics.css';
import '!style-loader!css-loader!../../css/quill.css';

export function runApp() {
  const context = createContext();

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
